import CollectionRulesModal from './CollectionRulesModal';

export default CollectionRulesModal;
